"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var server_1 = require("react-dom/server");
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var MobileLegendContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  min-height: 1.5rem;\n"], ["\n  display: flex;\n  min-height: 1.5rem;\n"])));
MobileLegendContainer.displayName = 'MobileLegendContainer';
var MobileLegendValue = styled_components_1.default.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n  text-transform: uppercase;\n  font-weight: normal;\n  font-size: x-small;\n"], ["\n  color: ", ";\n  text-transform: uppercase;\n  font-weight: normal;\n  font-size: x-small;\n"])), function (_a) {
    var colours = _a.theme.colours;
    return colours.charts.label;
});
MobileLegendValue.displayName = 'MobileLegendValue';
var MobileSeriesIndicator = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  height: 6px;\n  width: 6px;\n  margin-top: 4px;\n  margin-right: 4px;\n  background-color: ", ";\n"], ["\n  height: 6px;\n  width: 6px;\n  margin-top: 4px;\n  margin-right: 4px;\n  background-color: ", ";\n"])), function (_a) {
    var color = _a.color;
    return color;
});
MobileSeriesIndicator.displayName = 'MobileSeriesIndicator';
function mobileLegendItemFormatter(theme) {
    return function () {
        var _a = this, name = _a.name, visible = _a.visible;
        return server_1.renderToStaticMarkup(react_1.default.createElement(MobileLegendContainer, { visible: visible },
            'color' in this && react_1.default.createElement(MobileSeriesIndicator, { color: this.color }),
            react_1.default.createElement(MobileLegendValue, { theme: theme }, name)));
    };
}
exports.mobileLegendItemFormatter = mobileLegendItemFormatter;
exports.default = mobileLegendItemFormatter;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=mobile-legend-item-formatter.js.map